import React, { Fragment } from "react";
import spinner from "./spinner.gif";

const SpinnerSmall = () => (
  <Fragment>
    <img
      src={spinner}
      alt="Loading..."
      style={{
        width: "25px",
        margin: "auto",
        display: "block",
      }}
    />{" "}
  </Fragment>
);

export default SpinnerSmall;
